import { raTourLanguageEnglish } from '@react-admin/ra-tour';
import coreTranslationMessages from 'ra-language-english';

import commonTranslationsEn from '@Common/i18n/locales/en.json';

import { enTranslationsBoCommon } from '@sh4res/bo-common/i18n/en';
import { b2bAdminsTranslations } from '@sh4res/bo-common/i18n/en/b2b/admins';
import { b2bContractFeeChargesTranslations } from '@sh4res/bo-common/i18n/en/b2b/contract_fee_charges';
import { b2bContractsTranslations as b2bContractsTranslationsCommon } from '@sh4res/bo-common/i18n/en/b2b/contracts';
import { b2bIndividualOperationsTranslations } from '@sh4res/bo-common/i18n/en/b2b/individual_operations';
import { b2bInvestorProfileTranslations } from '@sh4res/bo-common/i18n/en/b2b/investor_profile';
import { b2bRecurringInvestmentsTranslations } from '@sh4res/bo-common/i18n/en/b2b/recurring_investments';
import { b2bWithdrawalsTranslations } from '@sh4res/bo-common/i18n/en/b2b/withdrawals';
import { instrumentsTranslations as instrumentsTranslationsCommon } from '@sh4res/bo-common/i18n/en/instruments';
import { taskStateTranslations } from '@sh4res/bo-common/i18n/en/tasks';
import { filterKeysByPrefix } from '@sh4res/bo-common/utils/filter_keys_by_prefix';

import { adminSelectorTranslations } from '@I18n/en/admin_selector';
import { appBarTranslations } from '@I18n/en/app_bar';
import { campaignsTranslations } from '@I18n/en/campaigns';
import { collectiveOperationsTranslations } from '@I18n/en/collective_operations';
import { companiesTranslations } from '@I18n/en/companies';
import { companiesDocumentsTranslations } from '@I18n/en/companies/documents';
import { contactSupportPageTranslations } from '@I18n/en/contact_support_page';
import { distributorTranslations } from '@I18n/en/distributor';
import { documentsTranslations } from '@I18n/en/documents';
import { employeesTranslations } from '@I18n/en/employees';
import { identityTranslations } from '@I18n/en/identity';
import { loginPageTranslations } from '@I18n/en/login_page';
import { maintenancePageTranslations } from '@I18n/en/maintenance_page';
import { ordersTranslations } from '@I18n/en/orders';
import { fullyManagedPlanContributionsTranslations } from '@I18n/en/orders/fully_managed_plan_contributions';
import { savingsFundsRequestsTranslations } from '@I18n/en/savings_funds_requests';
import { toursTranslations } from '@I18n/en/tours';

export const enTranslations = {
  ...coreTranslationMessages,
  ...filterKeysByPrefix(commonTranslationsEn, 'common.'),
  login_page: loginPageTranslations,
  maintenance_page: maintenancePageTranslations,
  app_bar: appBarTranslations,
  contact_support_page: contactSupportPageTranslations,
  ...raTourLanguageEnglish,
  'ra-tour': {
    action: {
      ...raTourLanguageEnglish['ra-tour'].action,
      last: 'Finish',
    },
  },
  'ra-preferences': {
    action: {
      choose_columns: 'Choose columns',
    },
  },
  'ra.validation.required': 'Error: field is required',
  'ra.validation.required.short': 'Required',
  'ra.validation.email': 'Error: must be a valid email',
  'ra.notification.application_update_available': 'New version available',
  'ra.action.update_application': 'Refresh',
  menu: {
    services: 'Services',
    employees: 'Employees',
    dashboard: 'Dashboard',
    company: 'Company',
    companies: 'Companies',
    contracts: 'Contracts',
    withdrawals: 'Withdrawals',
    fully_managed_plan_contributions: 'Fully Managed Plan Contributions',
    payouts: 'Payouts',
    campaigns: 'Campaigns',
    operations: 'Operations',
    savings_funds_requests: 'Operations',
    collective_operations: 'Operations',
    operations_er: 'Mandatory Contributions',
    distributor: 'Distributor',
    contract_fee_charges: 'Fees',
    instruments: 'Instruments',
    admins: 'Correspondents',
    orders: 'Orders',
    planned_operations: 'Planned Operations',
    recurring_voluntary_deposits: 'Recurring voluntary deposits',
    individual_operations: 'Individual Operations',
    documents: 'Documents',
  },

  footer: {
    brand: '@%{year} AXA all rights reserved',
    links_href: {
      accessibility: 'https://www.axa-mon-epargne-entreprises.com/declarations-accessibilite',
      data_protection:
        'https://axa-vitrine.wixstudio.com/vitrine-phenix/gestion-des-donn%C3%A9es-personnelles',
      cookie: 'https://axa-vitrine.wixstudio.com/vitrine-phenix/politique-des-cookies',
      sitemap: 'https://axa-vitrine.wixstudio.com/vitrine-phenix/plan-du-site',
      legal_information: 'https://axa-vitrine.wixstudio.com/vitrine-phenix/mentions-legales',
      contact_us: '/#/contact_support',
    },
    links_label: {
      accessibility: 'Accessibility: Conform',
      data_protection: 'Data protection',
      cookie: 'Cookie policy',
      sitemap: 'Sitemap',
      legal_information: 'Legal information',
      contact_us: 'Contact us',
    },
    social_media_links: {
      x: 'https://x.com',
      facebook: 'https://facebook.com',
      youtube: 'https://youtube.com',
      instagram: 'https://instagram.com',
    },
  },

  profile_popup: {
    logout: 'Sign out',
    contact_support: 'Contact support',
  },

  general: {
    sections: {
      details: 'Details',
    },
    upload: {
      dropzone: 'Drop a file, or select it',
    },
  },

  tours: toursTranslations,

  resources: {
    ...enTranslationsBoCommon,
    ...campaignsTranslations,
    ...collectiveOperationsTranslations,
    ...instrumentsTranslationsCommon,
    investor_profile: b2bInvestorProfileTranslations,
    companies: companiesTranslations,
    identity: identityTranslations,
    employees: employeesTranslations,
    admins: b2bAdminsTranslations,
    documents: documentsTranslations,
    orders: ordersTranslations,
    savings_funds_requests: savingsFundsRequestsTranslations,
    contracts: b2bContractsTranslationsCommon,
    'orders/fully_managed_plan_contributions': fullyManagedPlanContributionsTranslations,
    distributor: distributorTranslations,
    'companies/documents': companiesDocumentsTranslations,
    contract_fee_charges: b2bContractFeeChargesTranslations,
    individual_operations: b2bIndividualOperationsTranslations,
    recurring_investments: b2bRecurringInvestmentsTranslations,
    'recurring_investments/allocations': b2bRecurringInvestmentsTranslations.allocations,
    admin_selector: adminSelectorTranslations,
    tasks: { states: taskStateTranslations },
    withdrawals: b2bWithdrawalsTranslations,
  },
};
